import { QuizDiagnosticsTagColor } from '../../types'
import { ChapterViewDiagnostics, ChapterViewSection } from '../types'
import { ChapterViewApiResponse, ChapterViewApiSection } from '../types/api'

const TAG_COLOURS: QuizDiagnosticsTagColor[] = [
  'purple',
  'red',
  'blue',
  'green',
  'orange',
  'brown',
  'mathPurple',
  'aquamarine',
  'turquoise',
  'yellow',
  'grey',
  'terraCotta',
  'gold',
  'tangerine',
  'guacamole',
  'ultramarine',
  'grape',
  'moss',
  'slate'
]

const normalizeTagColour = (
  colour?: string | QuizDiagnosticsTagColor
): QuizDiagnosticsTagColor =>
  TAG_COLOURS.includes(colour as QuizDiagnosticsTagColor)
    ? (colour as QuizDiagnosticsTagColor)
    : 'grey'

const mapSection = (section?: ChapterViewApiSection): ChapterViewSection => ({
  id: section?.student_book_subchapter_id ?? '',
  title: section?.section_title ?? '',
  sectionOrder: section?.section_order ?? 0,
  sectionPart: section?.section_part,
  fiveQuizAverage: section?.five_quiz_average ?? 0,
  previousFiveQuizAverage: section?.previous_five_quiz_average ?? null,
  totalQuizzesTaken: section?.total_quizzes_taken ?? 0,
  hasQuizDueToday: section?.has_quiz_due_today,
  srqRedDotsVisible: section?.srq_red_dots_visible ?? true
})

const EMPTY_CHAPTER_VIEW: ChapterViewDiagnostics = {
  srqEnabled: false,
  srqRedDotsVisible: true,
  bookAverage: 0,
  bookTitle: '',
  tag: '',
  tagColour: 'grey',
  studentBookId: '',
  chapterId: '',
  chapterTitle: '',
  chapterOrder: 0,
  chapterAverage: 0,
  chapterSrqRedDotsVisible: true,
  totalQuizzesTaken: 0,
  sections: []
}

export const mapChapterApiResponse = (
  apiResponse?: ChapterViewApiResponse | null
): ChapterViewDiagnostics => {
  if (!apiResponse?.srq_enabled) {
    return EMPTY_CHAPTER_VIEW
  }

  const chapter = apiResponse.chapter

  return {
    srqEnabled: true,
    srqRedDotsVisible: apiResponse.srq_red_dots_visible ?? true,
    bookAverage: apiResponse.book_average ?? 0,
    bookTitle: apiResponse.book_title ?? '',
    tag: apiResponse.tag ?? '',
    tagColour: normalizeTagColour(apiResponse.tag_colour),
    studentBookId: apiResponse.student_book_id ?? '',
    chapterId: chapter?.student_book_chapter_id ?? '',
    chapterTitle: chapter?.chapter_title ?? '',
    chapterOrder: chapter?.chapter_order ?? 0,
    chapterAverage: chapter?.chapter_average ?? 0,
    chapterSrqRedDotsVisible: chapter?.srq_red_dots_effective ?? false,
    totalQuizzesTaken: chapter?.total_quizzes_taken ?? 0,
    sections: (chapter?.sections ?? [])
      .map(section => mapSection(section))
      .sort((left, right) => left.sectionOrder - right.sectionOrder)
  }
}
